import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "Vad gör plattformen?", a: "KitchenFlow samlar hela din meny — köksområden, rätter, komponenter och ingredienser — på ett ställe som hela teamet kan komma åt." },
  { q: "Hur lång tid tar uppsättningen?", a: "De flesta restauranger är igång på under 30 minuter." },
  { q: "Kan vi ändra saker i efterhand?", a: "Allt går att redigera — när som helst." },
  { q: "Behöver vi särskild hårdvara?", a: "Nej. Vi tillhandahåller allt som behövs." },
];

const FAQSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "center center"],
  });

  const opacity = useTransform(scrollYProgress, [0, 0.6], [0, 1]);
  const y = useTransform(scrollYProgress, [0, 0.6], [40, 0]);

  return (
    <section
      id="faq"
      ref={ref}
      className="bg-background py-[100px] md:py-[120px] px-6"
    >
      <motion.div style={{ opacity, y }} className="max-w-[640px] mx-auto w-full">
        <h2 className="text-[clamp(1.75rem,3.5vw,2.375rem)] font-bold tracking-tight text-foreground leading-[1.18] text-balance mb-12">
          Vanliga frågor
        </h2>

        <div className="soft-card px-6 md:px-8 py-2">
          <Accordion type="single" collapsible>
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b last:border-b-0"
                style={{ borderColor: "rgba(15,23,42,0.06)" }}
              >
                <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline py-5 text-[15px]">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent
                  className="text-sm pb-5 leading-relaxed"
                  style={{ color: "rgba(15,23,42,0.7)" }}
                >
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </motion.div>
    </section>
  );
};

export default FAQSection;
